/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetObservabilityOverviewPayload,
  GetObservabilityOverviewPayload$Outbound,
  GetObservabilityOverviewPayload$outboundSchema,
} from "../components/getobservabilityoverviewpayload.js";

export type GetObservabilityOverviewSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetObservabilityOverviewSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetObservabilityOverviewSecurity = {
  option1?: GetObservabilityOverviewSecurityOption1 | undefined;
  option2?: GetObservabilityOverviewSecurityOption2 | undefined;
};

export type GetObservabilityOverviewRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getObservabilityOverviewPayload: GetObservabilityOverviewPayload;
};

/** @internal */
export type GetObservabilityOverviewSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetObservabilityOverviewSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetObservabilityOverviewSecurityOption1$Outbound,
    GetObservabilityOverviewSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getObservabilityOverviewSecurityOption1ToJSON(
  getObservabilityOverviewSecurityOption1:
    GetObservabilityOverviewSecurityOption1,
): string {
  return JSON.stringify(
    GetObservabilityOverviewSecurityOption1$outboundSchema.parse(
      getObservabilityOverviewSecurityOption1,
    ),
  );
}

/** @internal */
export type GetObservabilityOverviewSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetObservabilityOverviewSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetObservabilityOverviewSecurityOption2$Outbound,
    GetObservabilityOverviewSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getObservabilityOverviewSecurityOption2ToJSON(
  getObservabilityOverviewSecurityOption2:
    GetObservabilityOverviewSecurityOption2,
): string {
  return JSON.stringify(
    GetObservabilityOverviewSecurityOption2$outboundSchema.parse(
      getObservabilityOverviewSecurityOption2,
    ),
  );
}

/** @internal */
export type GetObservabilityOverviewSecurity$Outbound = {
  Option1?: GetObservabilityOverviewSecurityOption1$Outbound | undefined;
  Option2?: GetObservabilityOverviewSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetObservabilityOverviewSecurity$outboundSchema: z.ZodMiniType<
  GetObservabilityOverviewSecurity$Outbound,
  GetObservabilityOverviewSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetObservabilityOverviewSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetObservabilityOverviewSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getObservabilityOverviewSecurityToJSON(
  getObservabilityOverviewSecurity: GetObservabilityOverviewSecurity,
): string {
  return JSON.stringify(
    GetObservabilityOverviewSecurity$outboundSchema.parse(
      getObservabilityOverviewSecurity,
    ),
  );
}

/** @internal */
export type GetObservabilityOverviewRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetObservabilityOverviewPayload: GetObservabilityOverviewPayload$Outbound;
};

/** @internal */
export const GetObservabilityOverviewRequest$outboundSchema: z.ZodMiniType<
  GetObservabilityOverviewRequest$Outbound,
  GetObservabilityOverviewRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getObservabilityOverviewPayload:
      GetObservabilityOverviewPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getObservabilityOverviewPayload: "GetObservabilityOverviewPayload",
    });
  }),
);

export function getObservabilityOverviewRequestToJSON(
  getObservabilityOverviewRequest: GetObservabilityOverviewRequest,
): string {
  return JSON.stringify(
    GetObservabilityOverviewRequest$outboundSchema.parse(
      getObservabilityOverviewRequest,
    ),
  );
}
